export const quickstartContent = `# Quickstart

6-step checklist to get up and running with Lightswitch:

1. **Install** → \`npm i lightswitch-js\`
2. **Create app/keys** → Run provisioning script to generate publishable key and appSlug
3. **Set Supabase config** → Configure your Supabase client
4. **Optional Stripe setup** → Add payment processing for paid apps
5. **Wrap provider** → Add LightswitchProvider to your app root
6. **Protect a route** → Use ProtectedRoute for paid content

For detailed implementation, see **Access & Paywall → React Quickstart**.`;
